import styled from 'styled-components'

export const CopySettingsLayout = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 5px 36px;
`

CopySettingsLayout.displayName = 'CopySettingsLayout'
